/**
 * ContactDialing component (Call Us page redesign container)
 * Using ErrorHandler to handle Error case in the Call us page, which is same with current Call Us error handler
 */

import React from 'react';

// Helper
import Page from '../../lib/page';
import ModalContainer from '../containers/ModalContainer';
import ErrorHandler from '../containers/ErrorHandler';
import Callus from '../containers/Call';

// Constants
const { error: { contact } } = Page.getLocaleContent('Error');

const renderCallusPage = () => <Callus />;

const ContactDialing = () => (
  <ErrorHandler contactError={contact}>
    <div>
      <ModalContainer />
      {renderCallusPage()}
    </div>
  </ErrorHandler>
);

export default ContactDialing;
